<script setup>
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useAddressStore } from '@stores/useAddressStore';
import SellerBrandPhotoAdd from './SellerBrandPhotoAdd.vue';
import SellerBrandPhotoCard from './SellerBrandPhotoCard.vue';

const store = useAddressStore();
const { images } = storeToRefs(store);
const dragStart = ref(false);
const dragOverIndex = ref(null);
const dragStartIndex = ref(null);

const onDragStart = (index) => {
  dragStartIndex.value = index;
  dragStart.value = true;
};

const onDragEnter = (index) => {
  dragOverIndex.value = index;
};

const onDragEnd = () => {
  dragStart.value = false;

  if (dragOverIndex.value === dragStartIndex.value) {
    return;
  }

  const dragFromImage = images.value[dragStartIndex.value];

  images.value.splice(dragStartIndex.value, 1);
  images.value.splice(dragOverIndex.value, 0, dragFromImage);

  dragOverIndex.value = null;
  dragStartIndex.value = null;

  store.persistMediaDisplayOrder();
};
</script>

<template>
  <div>
    <SellerBrandPhotoAdd />

    <SellerBrandPhotoCard
      v-for="(image, index) in images"
      :key="image.index"
      :image="image"
      :index="index"
      :over="dragStart && dragOverIndex === index"
      :drag-started-index="dragStart && dragStartIndex === index"
      @drag-start="onDragStart"
      @drag-enter="onDragEnter"
      @drag-end="onDragEnd"
    />
  </div>
</template>
